import { createSelector } from 'reselect';

const errorState = state => state.suggestions.error;
const suggestionsState = state => state.suggestions.data;

export const errorSelector = createSelector(
  errorState,
  error => error
);
export const suggestionsSelector = createSelector(
  suggestionsState,
  data => data
);



// WEBPACK FOOTER //
// ./app/Suggestions/selectors.js